import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import React from 'react'
import * as Yup from "yup";
import CustomTextField from '../CustomTextField/CustomTextField';
import CustomSubmitButton from '../CustomSubmitButton/CustomSubmitButton';
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { USER_INTERPRETO_ACCOUNT_REJECT_FIRST } from '../../Redux/Slices/UserSlice/User.action';
const CustomRejectInterpreter = (props) => {
    const dispatch = useDispatch();
    const { open, onClose, userId, handleOnClose, status, handleSubmitAcceptReject } = props;
    const [isLoading, setIsLoading] = React.useState(false);
    const formik = useFormik({
        initialValues: {
            rejectReason: "",
        },
        validationSchema: Yup.object().shape({
            rejectReason: Yup.string().required("Reject reason is required!"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            if (isLoading) {
                return
            } else {
                const formData = new FormData();
                formData.append('interpreter_verified', status);
                formData.append('reject_reason', values?.rejectReason);
                await dispatch(USER_INTERPRETO_ACCOUNT_REJECT_FIRST({ userId, formData })).unwrap()
                    .then((res) => {
                        if (res && res?.s === 1) {
                            toast.success("Request Rejected Successfully!");
                            resetForm();
                            setIsLoading(false);
                            handleSubmitAcceptReject();
                            handleOnClose();
                        } else {
                            toast.error(res?.m);
                            setIsLoading(false);
                        }
                    }).catch((error) => {
                        console.log('Error:', error);
                        toast.error("Something went wrong. Please try again.");
                        setIsLoading(false);
                    });
            }
        },
    });
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "20px",
                    padding: '20px 30px',
                    height: "auto",
                    overflow: "scroll",
                    "::-webkit-scrollbar": { width: "0px", height: '0px' },
                    display: "flex",
                    flexDirection: "column",
                },
                "& .MuiDialogContent-root": {
                    overflowY: "initial",
                    flexGrow: 1,
                },
                "& .MuiBackdrop-root": {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                }
            }}
        >
            <form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>
                            Enter Reject Reason
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <IconButton
                                sx={{
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#101010',
                                    borderRadius: '8px',
                                    "&:hover": { backgroundColor: '#101010', color: '#fff' }
                                }}
                                onClick={handleOnClose}
                            >
                                <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ padding: '20px 0px 0px 0px', flexGrow: 1 }}>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Description"
                                type="text"
                                placeholder="Enter Description"
                                name="rejectReason"
                                multiline
                                rows={4}
                                value={formik.values.rejectReason}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                errors={formik.touched.rejectReason && formik.errors.rejectReason}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    formik.handleChange(e);
                                }}
                            />
                        </Grid>

                    </Grid>
                </Box>

                <Box sx={{ paddingTop: '20px' }}>
                    <CustomSubmitButton
                        btnTitle="Done"
                        loading={isLoading}
                        type="submit"
                    />
                </Box>
            </form>
        </Dialog>
    )
}
export default CustomRejectInterpreter;